import { Link } from 'react-router-dom';
import { categories } from '@/mocks/yihao';

export default function CategorySection() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">娱乐分类</h2>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto">
            多元化娱乐内容，满足您的不同需求。五大娱乐板块，精彩纷呈，总有一款适合您。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-xl overflow-hidden cursor-pointer h-[280px]"
            >
              <img
                src={cat.image}
                alt={`${cat.name}娱乐分类`}
                title={`壹号娱乐${cat.name}`}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-5">
                <div className="w-10 h-10 rounded-lg bg-primary-500/80 backdrop-blur-sm flex items-center justify-center mb-3">
                  <i className={`${cat.icon} text-white text-lg`}></i>
                </div>
                <h3 className="text-white font-heading font-bold text-lg mb-1">{cat.name}</h3>
                <p className="text-white/75 text-xs line-clamp-2">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}